export const mapToneToLabel = {
  NEUTRAL: 'Neutral',
  CASUAL: 'Casual',
  FORMAL: 'Formal',
};

export const mapPersonalityToLabel = {
  FRIENDLY: 'Friendly',
  CONFIDENT: 'Confident',
  UPLIFTING: 'Uplifting',
  AMUSING: 'Amusing',
  EMPATHETIC: 'Empathetic',
  ENGAGING: 'Engaging',
  DIRECT: 'Direct',
  INSPIRING: 'Inspiring',
};

export const maxPersonalities = 3;

export const toneNumberName = 'one';

export const prebuiltSuggestions = [
  {
    key: 'renewalEmails',
    label: 'Write a renewals reminder email',
    emojiClass: 'email-reminder',
  },
];

export const LEVEL_MAP = {
  account: 'accounts',
  organization: 'organizations',
};
